// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"23aeff0b","398":"23aeff0b","748":"511cb8e0","903":"23aeff0b","962":"911d73f1"}[chunkId] + ".chunk.css";
};